<template>
  <div class="search-all">
    <el-checkbox
      v-model="checkAll"
    >
      群体对比
    </el-checkbox>
    <div v-if="checkAll">
      <div class="mt10">
        <el-radio-group v-model="searchParams.groupBetweenCompareType" @change="changeSearch">
          <el-radio :label="101" size="large">年级对比</el-radio>
          <el-radio :label="103" size="large">班级对比</el-radio>
        </el-radio-group>
      </div>

      <div class="search-box mt10">
        <div v-if="searchParams.groupBetweenCompareType === 101">
          <div class="row flex">
            <div class="label flex-center">
              班级
            </div>
            <div class="row-con flex items-c">
              <el-checkbox-group
                v-model="searchParams.compareIds"

                @change="handleAgeCheckedChange"
              >
                <el-checkbox
                  v-for="item in $enums.classroomTypes"
                  :key="item.code"
                  :label="item.code"
                >
                  {{ item.description }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <div class="row flex">
            <div class="label flex-center">性别</div>
            <div class="row-con flex items-c">
              <el-checkbox-group v-model="searchParams.sexes" :min="1">
                <el-checkbox
                  v-for="item in $enums.gender"
                  :key="item.code"
                  :label="item.code"
                >
                  {{ item.description }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
        <div v-if="classShow && searchParams.groupBetweenCompareType === 103">
          <div class="row flex">
            <div class="label flex-center class">班级</div>
            <div class="row-con">
              <div v-if="classList.length > 0">
                <div v-for="(v, index) in classList" :key="index" class="flex">
                  <div class="class-label flex items-c">
                    <div class="check-all">
                      <el-checkbox
                        v-model="v.checkAll"
                        @change="handleCheckAllClassChange($event, index)"
                      >
                        {{ v.name }}
                      </el-checkbox>
                    </div>
                  </div>
                  <div class="row-con flex items-c class-check-box">
                    <el-checkbox-group v-model="v.ids" @change="idsChange(index)">
                      <el-checkbox
                        v-for="(q, qIndex) in v.classrooms"
                        :key="qIndex"
                        :label="q.id"
                      >
                        {{ q.name }}
                      </el-checkbox>
                    </el-checkbox-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row flex">
            <div class="label flex-center">性别</div>
            <div class="row-con flex items-c">
              <el-checkbox-group v-model="searchParams.sexes" :min="1">
                <el-checkbox
                  v-for="item in $enums.gender"
                  :key="item.code"
                  :label="item.code"
                >
                  {{ item.description }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getClassList
} from '@/api/teachingProtection/assessment'
export default {
  props: {
    params: {}
  },
  data() {
    return {
      classList: [],
      classShow: true,
      searchParams: {
        sexes: [101, 102],
        classroomIds: [],
        compareIds: [],
        year: '',
        semesterType: '',
        periodType: '',
        groupBetweenCompareType: 101
      },
      checkAllAge: false,
      checkAll: true
    }
  },
  created() {
    getClassList().then((res) => {
      this.classList = res.data.array.filter((v) => {
        return v.name !== '其他'
      })
      this.classList.map((v, index) => {
        v.ids = []
        let checkedCount = this.classList[index].ids.length
        this.classList[index].checkAll =
            checkedCount === this.classList[index].classrooms.length
      })
    })
  },
  mounted() {
    this.searchParams.year = this.params.year
    this.searchParams.semesterType = this.params.semesterType
    this.searchParams.periodType = this.params.periodType
  },
  methods: {
    handleCheckAllAgeChange(val) {
      const arr = []
      this.$enums.classroomTypes.map((v) => {
        arr.push(v.code)
      })
      if (val) {
        this.searchParams.compareIds = arr
      } else {
        this.searchParams.compareIds = []
      }
    },
    idsChange(index) {
      this.classShow = false
      this.$nextTick(() => {
        this.classShow = true
        let checkedCount = this.classList[index].ids.length
        this.classList[index].checkAll =
          checkedCount === this.classList[index].classrooms.length
      })
      this.resetClassroomIds()
    },
    handleCheckAllClassChange(val, index) {
      const arr = []
      this.classList[index].classrooms.map((v) => {
        arr.push(v.id)
      })
      if (val) {
        this.classList[index].ids = arr
      } else {
        this.classList[index].ids = []
      }
      this.classShow = false
      this.$nextTick(() => {
        this.classShow = true
      })
      this.resetClassroomIds()
    },
    handleAgeCheckedChange(val) {
      let checkedCount = val.length
      this.checkAllAge =
        checkedCount === this.$enums.classroomTypes.length
    },
    changeSearch(tab) {
      this.searchParams.groupBetweenCompareType = tab
      this.reset()
    },
    resetClassroomIds() {
      const arr = []
      this.classList.map((v) => {
        v.ids.map((q) => {
          arr.push(q)
        })
      })
      this.searchParams.classroomIds = arr
    },
    reset() {
      this.searchParams.classroomIds = []
      this.searchParams.sexes = [101, 102]
      this.searchParams.compareIds = []
      this.checkAllAge = false
      this.classList.map((v) => {
        v.checkAll = false
        v.ids = []
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.down-btn{
  width: 120px;
}
.search-all{
  border: 1px solid #EFEFEF;
  border-radius: 4px;
  padding: 20px;
  box-shadow: 4px 4px 8px 0px rgba(153,153,153,0.11);

}
.search-box {
  border: 1px solid #e8edf2;
  .row {
    border-bottom: 1px solid #e8edf2;
    .label {
      background: #f5f7fa;
      width: 60px;
      min-height: 36px;
    }
    .class {
      min-height: 85px !important;
    }
    .row-con {
      padding: 10px 20px;
      width: 100%;
    }
    .check-all {
      margin: 5px 0;
    }
  }
}
</style>
